import { sumPdfPagesInFiles } from './pdfPageCount';

/** Paper 5LP-0 — multi-upload system line for the chat thread */
export async function buildMultiFileLoadedSystemMessage(files: File[]): Promise<{
  content: string;
  systemKind: 'multi_files_loaded';
}> {
  const n = files.length;
  const pages = await sumPdfPagesInFiles(files);
  const content =
    pages > 0
      ? `${n} files loaded — ${pages} pages total. What would you like to do?`
      : `${n} files loaded. What would you like to do?`;
  return { content, systemKind: 'multi_files_loaded' };
}
